define('drops/calendarYearView/calendarYearView',[
    'jquery',
    'underscore',
    'luxon',
    'globalize',
    'lq/drop',
    'lq/constants',
    'drops/calendar/calendarParameter',
    'drops/calendar/daysofmonthcalendar',
    'tpl!drops/calendarYearView/calendarYearView.html'
], function ($, _, luxon, globalize, Drop, constants, calendarParameter, DaysOfMonthCalendar, template) {
    'use strict';

    const { DateTime } = luxon;

    var defaults ={
        data: {
            dataSource: null,
            dateOutput: null,
            tooltipOutput: null,
            colorOutput: null,
            fontColorOutput: null,
            isUnavailableOutput: null,
            calendarStartParameter: 'CalendarYearStart',
            calendarEndParameter: 'CalendarYearEnd',
            monthTitleFormat: 'MMMM yyyy',
            showWeekdayHeaders: false,
            weekdayHeadersFormat: 'ddd',
            eventing: {
                clicked: {}
            }
        }
    };

    function CalendarYearView(options) {
        Drop.call(this, $(template()), defaults, options);
        this.selectedDate = null;
    };

    Drop.extend(CalendarYearView, Drop);

    CalendarYearView.typeName = 'CalendarYearView';

    CalendarYearView.prototype.loadCalendarData = function () {
        if (!this.data.dataSource)
            return;

        var dateOfRequestedData = this.date;

        var self = this;
        this.piping.queryDispatcher.backgroundDispatch(
            this.data.dataSource,
            function (response) {
                if (dateOfRequestedData.equals(self.date))
                    self.showColors(response.results);
            });
    };

    CalendarYearView.prototype.setSelectedDate = function (date) {
        this.clearSelectedDate();

        var calendar = this.getCalendarForDate(date);
        calendar.setSelectedDate(date);

        this.selectedDate = date;
    };

    CalendarYearView.prototype.clearSelectedDate = function () {
        if (!this.selectedDate)
            return;

        var calendar = this.getCalendarForDate(this.selectedDate);
        calendar.clearSelectedDate();

        this.selectedDate = null;
    };

    CalendarYearView.prototype.init = $.noop;

    CalendarYearView.prototype.getSelectedDate = function () {
        return this.selectedDate;
    };

    CalendarYearView.prototype.getCalendarForDate = function (date) {
        var calendarIndex = date.get('month');
        return this.calendars[calendarIndex];
    };

    CalendarYearView.prototype.render = function () {
        this.registerForDataSource();
        this.prepareUi();
        this.open(DateTime.now());
    };

    CalendarYearView.prototype.prepareUi = function () {
        var setup = {
            standalone: false,
            titleFormat: this.data.monthTitleFormat,
            showWeekdayHeaders: this.data.showWeekdayHeaders,
            weekdayHeadersFormat: this.data.weekdayHeadersFormat,
            languageISOCode: this.piping.parameters.getValue('CurrentLanguageISOCode')
        };

        var self = this;
        this.calendars = _.map(_.range(0, 12), function () {
            return new DaysOfMonthCalendar(setup);
        });

        if (this.data.eventing.clicked.enabled) {
            _.each(this.calendars, function (calendar) {
                calendar.withOnClicked(function (date) {
                    if (self.selectedDate && !date.hasSame(self.selectedDate, 'month'))
                        self.clearSelectedDate();
                    self.selectedDate = date;

                    var arg = globalize.format(date.toJSDate(), constants.licquidDateFormat);
                    self.triggerEventIfEnabled('clicked', arg);
                });
            });
        }

        this.$title = this.$element.find('.date-as-title');

        var $calendars = _.pluck(this.calendars, '$element');
        this.$element.find('.calendar-main').append($calendars);

        this.$element.find('.previous-page')
            .on('click', function () {
                self.previous();
            });
        this.$element.find('.next-page')
            .on('click', function () {
                self.next();
            });
    };

    CalendarYearView.prototype.registerForDataSource = function () {
        if (this.data.dataSource) {
            var self = this;
            this.piping.datasources.registerDatasourceListener(this.data.dataSource, function (data) {
                _.each(self.calendars, function(calendar) {
                    calendar.rerender();
                });
                self.showColors(data.results);
            });
        }
    };

    CalendarYearView.prototype.previous = function () {
        this.open(this.date.minus({ years: 1 }));
        this.loadCalendarData();
        this.triggerNavigatedEvent();
    };

    CalendarYearView.prototype.next = function () {
        this.open(this.date.plus({ years: 1 }));
        this.loadCalendarData();
        this.triggerNavigatedEvent();
    };

    CalendarYearView.prototype.triggerNavigatedEvent = function () {
        this.triggerEventIfEnabled('navigated', this.getStartOfCurrentYear());
    };

    CalendarYearView.prototype.open = function (date) {
        this.date = date;

        this.$title.text(this.date.get('year'));

        for (var i = 0; i < 12; i++) {
            var calendarDate = this.date.startOf('year').plus({ months: i });
            this.calendars[i].open(calendarDate);
        }

        var parameters = this.piping.parameters;
        parameters.locals.setValue(this.data.calendarStartParameter, this.getStartOfCurrentYear());
        parameters.locals.setValue(this.data.calendarEndParameter, this.getEndOfCurrentYear());
    };

    CalendarYearView.prototype.getStartOfCurrentYear = function() {
        return calendarParameter.convert(this.date.startOf('year'));
    };

    CalendarYearView.prototype.getEndOfCurrentYear = function () {
        return calendarParameter.convert(this.date.endOf('year'));
    };

    CalendarYearView.prototype.showColors = function (results) {
        var self = this;
        _.each(results, function (row) {
            var date = new Date(row[self.data.dateOutput]);
            var backgroundColor = row[self.data.colorOutput];
            var fontColor = row[self.data.fontColorOutput];
            var tooltip = row[self.data.tooltipOutput];
            var isUnavailable = row[self.data.isUnavailableOutput];
            var calendar = self.calendars[date.getMonth()];
            calendar.decorateDate(date, backgroundColor, fontColor, tooltip, isUnavailable);
        });
    };

    CalendarYearView.prototype.getOpenDate = function () {
        return this.date;
    };

    return CalendarYearView;
});
